import { render, staticRenderFns } from "./PpvStatCard.vue?vue&type=template&id=7c0cbf1d&scoped=true"
import script from "./PpvStatCard.vue?vue&type=script&lang=js"
export * from "./PpvStatCard.vue?vue&type=script&lang=js"
import style0 from "./PpvStatCard.vue?vue&type=style&index=0&id=7c0cbf1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0cbf1d",
  null
  
)

export default component.exports